import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=60b7ca19&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"
import style0 from "./Invite.vue?vue&type=style&index=0&id=60b7ca19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7ca19",
  null
  
)

export default component.exports